import * as styles from "./styles.css";
export const Checkbox = ({ checked, onClick }) => (React.createElement("div", { className: styles.checkboxContainer },
    React.createElement("div", { className: styles.round, onClick: onClick },
        React.createElement("input", { type: "checkbox", id: "checkbox", checked: checked, onClick: onClick, onChange: () => { } }),
        React.createElement("label", { htmlFor: "checkbox", className: styles.label }))));

